import { Component, ErrorInfo, ReactNode } from 'react';
import {
  handleWalletConnectSessionError,
  isWalletConnectSessionError,
} from 'utils/globalErrorHandler';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

/**
 * Error Boundary component that catches WalletConnect session errors
 * and triggers automatic reload
 */
export class WalletConnectErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('[Error Boundary] Caught error:', error, errorInfo);

    // Check if it's a WalletConnect session error
    if (isWalletConnectSessionError(error)) {
      console.log(
        '[Error Boundary] WalletConnect session error detected, handling...'
      );
      handleWalletConnectSessionError(error);
    }

    throw error; // Re-throw the error to avoid silent failures
  }
  

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      throw this.state.error || null;
    }

    return this.props.children;
  }
}
